import { useState, useEffect } from 'react';

function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {

    if (typeof window === 'undefined' || !window.matchMedia) {
      console.warn('matchMedia is not supported');
      return;
    }
    
    const media = window.matchMedia(query);

    // Set the initial value
    setMatches(media.matches);

    // Define our event listener
    const listener = () => setMatches(media.matches);

    // Use the more modern `addEventListener` if available
    if (media.addEventListener) {
      media.addEventListener('change', listener);
    } else {
      // Fallback for older browsers
      media.addListener(listener);
    }

    // Cleanup
    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener);
      } else {
        // Fallback cleanup for older browsers
        media.removeListener(listener);
      }
    };
  }, [query]);

  return matches;
}

export default useMediaQuery;